import {Component} from '@angular/core';
import {Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import {OnInit} from '@angular/core/src/metadata/lifecycle_hooks';
import {AuthGuardService} from '../../services/auth-guard.service';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';

@Component({
  selector: 'app-route',
  templateUrl: './login.html',
  styleUrls: ['./login.scss']
})
export class LoginComponent  {
  public constructor() {
   
  }

  
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.ts